import { createContext, useState, useEffect } from 'react'
import api from '../utils/api'

export const AuthContext = createContext(null)

// ─── Permission helper ────────────────────────────────────────────────────────
const ROLE_DEFAULTS = {
  admin:            { can_bulk_import:true,  can_edit_fields:true,  can_change_status:true,  can_export:true,  can_view_pii:true,  can_view_evidence:true,  can_view_all_regions:true  },
  reviewer:         { can_bulk_import:false, can_edit_fields:true,  can_change_status:true,  can_export:true,  can_view_pii:true,  can_view_evidence:true,  can_view_all_regions:false },
  readonly:         { can_bulk_import:false, can_edit_fields:false, can_change_status:false, can_export:false, can_view_pii:false, can_view_evidence:false, can_view_all_regions:false },
  organization:     { can_bulk_import:true,  can_edit_fields:false, can_change_status:false, can_export:false, can_view_pii:false, can_view_evidence:false, can_view_all_regions:false },
  legal_org:        { can_bulk_import:false, can_edit_fields:false, can_change_status:false, can_export:true,  can_view_pii:true,  can_view_evidence:true,  can_view_all_regions:false },
  field_researcher: { can_bulk_import:false, can_edit_fields:false, can_change_status:false, can_export:false, can_view_pii:false, can_view_evidence:false, can_view_all_regions:false },
}

function resolvePermissions(user) {
  const defaults = ROLE_DEFAULTS[user?.role] || {}
  return { ...defaults, ...(user?.permissions || {}) }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => sessionStorage.getItem('admin_token'))
  const [user, setUser] = useState(() => {
    try {
      const u = sessionStorage.getItem('admin_user')
      return u ? JSON.parse(u) : null
    } catch {
      return null
    }
  })

  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      delete api.defaults.headers.common['Authorization']
    }
  }, [token])

  const login = async (username, password) => {
    const { data } = await api.post('admin/login', { username, password })
    const { token: t, user: u } = data
    // Ensure permissions is the resolved effective object
    const enriched = { ...u, permissions: resolvePermissions(u) }
    setToken(t)
    setUser(enriched)
    sessionStorage.setItem('admin_token', t)
    sessionStorage.setItem('admin_user', JSON.stringify(enriched))
    api.defaults.headers.common['Authorization'] = `Bearer ${t}`
    return enriched
  }

  const logout = () => {
    setToken(null)
    setUser(null)
    sessionStorage.removeItem('admin_token')
    sessionStorage.removeItem('admin_user')
    delete api.defaults.headers.common['Authorization']
  }

  // Helper: check a permission flag
  const can = (perm) => !!(user?.permissions?.[perm])

  return (
    <AuthContext.Provider value={{ token, user, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  )
}
